'use strict';
angular.module('atex.dam').factory("ExportService", ['$q', 'DamService', 'ContentService', 'DamNotificationService', '$translate',
  function($q, DamService, ContentService, DamNotificationService, $translate) {

  var _clipboardExportSingle = function(entry) {
    var deferred = $q.defer();
    var _id;
    DamService.exportContent(entry.id).then(function(result) {
      _id = result.data;
      return ContentService.getContent({id : result.data});
    }).then(function(response) {
      var data = {
        id: 'contentid/'+response.data.id,
        type: response.data.aspects.contentData.data._type
      };
      var info = {
        id: _id
      };
      deferred.resolve({
        clipboardData: data,
        engagement: info
      });
    }).then(null, function(error) {
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $translate.getTranslationTable().__ERROR_DURING_EXPORT__ }), true);
      deferred.reject(error);
    });
    return deferred.promise;
  };

  var _exportSingle = function(entry, inputTemplate, destination, status) {
    var deferred = $q.defer();
    DamService.exportContent(entry.id, null, inputTemplate, destination, status).then(function(result) {
      deferred.resolve({id: result.data});
    }).then(null, function(error) {
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: $translate.getTranslationTable().__ERROR_DURING_EXPORT__ }), true);
      deferred.reject(error);
    });
    return deferred.promise;
  };

  return {

    clipboardExport: function(entries) {
      var deferred = $q.defer();

      var exportPromises = entries.map(function(entry) {
        return _clipboardExportSingle(entry);
      });

      var clipboardInfo = {
          data: []
      };
      var infos = [];

      $q.all(exportPromises).then(function(responses) {
        responses.forEach(function(response) {
          clipboardInfo.data.push(response.clipboardData);
          infos.push(response.engagement);
        });
        deferred.resolve({
          clipboard: clipboardInfo,
          engagement:infos
        });
      });

      return deferred.promise;
    },

    export: function(entries, inputTemplate, destination, status) {
      var deferred = $q.defer();

      var exportPromises = entries.map(function(entry) {
        return _exportSingle(entry, inputTemplate, destination, status);
      });

      var info = [];

      $q.all(exportPromises).then(function(responses) {
        responses.forEach(function(response) {
          info.push(response);
        });
        deferred.resolve(info);
      });

      return deferred.promise;
    }

  };

}]);
